import React from "react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/members/$memberId")({
  // eslint-disable-next-line i18next/no-literal-string
  component: () => <div>Hello /members/$memberId!</div>,
});
